<template>
  <div>
    <dialogos-app :dialogos="dialogos"></dialogos-app>
    <v-layout wrap mt-3>
      <v-flex xs6 text-xs-center v-for="i in 2" :key="alts[i]">
        <button class="hvr-scale" :class="vistos[i-1]?'bot-check-vis-cen':''" @click="currentText = i, $set(vistos,i-1,true)">
          <img :src="require('../../assets/Modulo 1/diapositiva-2-'+ i +'.png')" :alt="alts[i-1]">
        </button>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xs12 lg8 v-if="text != ''">
        <transition name="custom" appear-active-class="animated fadeInUp faster" enter-active-class="animated fadeInUp faster" leave-active-class="animated fadeOutDown faster" mode="out-in">
          <p class="texto1 mt-4" :key="text">
            <span v-html="text"></span>
          </p>
        </transition>
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 02'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "A continuación, detallaremos los aspectos generales de las reservas y los recursos en el contexto de ECOPETROL S.A. <span class='instruccion'>Haz clic en los iconos.</span>" 
      ],
      alts: [
        "",
        ""
      ],
      vistos: [false,false],
      currentText: 0
    }
  },
  computed: {
    text: function() {
      switch (this.currentText){
        case 1: return "Las reservas y los recursos de hidrocarburos constituyen un activo fundamental para el cumplimiento del plan estratégico definido por la compañía. Por lo cual, es de gran importancia garantizar un proceso interno de estimación y reporte de reservas que cumpla con las exigencias normativas, de control y de reporte, establecidos interna y externamente.";
        case 2: return "Las reservas y los recursos le permiten a ECOPETROL S.A. buscar un negocio a largo plazo; el objetivo es convertir a la compañía en un jugador internacional con capacidad para incorporar reservas y aumentar la producción de petróleo y gas de manera sostenible.";
        default: return ""
      }
    }
  },
  created() {
    this.$store.commit('nextShow', false)
  },
  watch: {
    vistos: function(newValue){
      var todosVistos = newValue.every(el => {return el})
      if(todosVistos) {
        this.$store.commit('nextShow', true)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
